import pipe from 'ramda/src/pipe'
import assocPath from 'ramda/src/assocPath'
import dropAddEventPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/dropAddEventPayloadSchema'

export default pipe(
	assocPath(['properties', 'dropEventPayload', 'properties', 'id'], { type: 'string' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'budget'], { type: 'object' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'mnemonicId'], { type: 'string' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'isGameFree'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'isMultiGame'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'isPrivate'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'isUserActivated'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'awardPoints'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'isCommunityDrop'], { type: 'boolean' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'daresCountResetDate'], { type: 'string' }),
	assocPath(['properties', 'dropEventPayload', 'properties', 'expirationDate'], { type: 'string' }),
	assocPath(['properties', 'dropEventPayload', 'required'], ['id']),
)(dropAddEventPayloadSchema)
